import { Flex, Typography } from "antd"
import numeral from "numeral"
import { round } from "shared/utils"


export type KeyValueItemProps = {
    label: React.ReactNode,
    value: React.ReactNode
}

export type KeyNumberItemProps = {
    label: string,
    value?: number,
    postfix?: string,
    style?: React.CSSProperties
}

const { Text } = Typography;

const formatNumber = (num?: number) => {
    const value = num ?? 0
    if (value !== 0 && value < 0.01 && value > -0.01) return numeral(value).format("0.000e+0")
    return round(value, 3)
}

export const KeyValueItem = (props: KeyValueItemProps) => {
    return <Flex className="flex justify-between" >
        {typeof props.label === 'string' ? <div>{props.label}</div> : props.label}
        {typeof props.value === 'string' ? <div>{props.value}</div> : props.value}
    </Flex>
}

export const KeyNumberItem = (props: KeyNumberItemProps) => {
    return <Flex className="flex justify-between" >
        <div style={props.style}>{props.label}</div>
        <Text style={props.style} type={(props.value ?? 0) < 0 ? "danger" : "success"} >{formatNumber(props.value)}{props.postfix && props.postfix}</Text>
    </Flex>
}